export const neutralColors = {
  neutral100: '#02315B',
  utilityWhite: '#FFF',
} as const;
